export default __webpack_public_path__ + "static/media/edit.5529feb3.svg";